export const ProjectMemberValidation = (formData) => {
    const errors = {};
  
    // Validate each field
  
    if (!formData.ProjectID.toString().trim()) {
      errors.ProjectID = 'This field is required';
    }
    if (!formData.UserID.toString().trim()) {
        errors.UserID = 'This field is required';
      } 
  
    return errors;
  };
  
 